import React, { useState } from 'react';
import { Box } from '@mui/material';
import { registerUser } from '../api/api';
import './login.css';

const RegisterForm = () => {
  const [type, setType] = useState('student');
  const [errMessage, setErrMessage] = useState(''); // Change to a string
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [profilePicture, setProfilePicture] = useState('');
  const [nationality, setNationality] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [address, setAddress] = useState({ city: '', country: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      type,
      name,
      email,
      password,
      profilePicture,
      nationality: type === 'student' ? nationality : undefined, // Only if type is 'student'
      attachments,
      address: type === 'university' ? address : undefined // Only if type is 'university'
    };

   

    try {
      if(type === 'university') {
        alert("NB: Veuillez noter qu'il est obligatoire qu'on authentifie cette université après la création de ce compte");
      }
      const response = await registerUser(formData);
      window.location.href = '/connexion'; // Rediriger après inscription
    } catch (error) {
      if (error.status === 409) { // Check for conflict error (email already used)
        setErrMessage('Erreur d\'inscription : Cette adresse Email est déjà utilisée!');
      } else {
        setErrMessage('Erreur d\'inscription : ' + (error.message || error)); // Fallback to a generic error message
      }
    }
    
  };

  return (
    <Box className="login-page">
      <Box className="login-container">
        <form onSubmit={handleSubmit} >
          <div className="form-group">
            {errMessage && <p style={{ color: 'red' }}>{errMessage}</p>} {/* Show error message if exists */}
            <label>Type de Compte</label>
            <select value={type} onChange={(e) => setType(e.target.value)} className="input-field">
              <option value="student">Étudiant</option>
              <option value="university">Université</option>
            </select>
          </div>

          <div className="form-group">
            <input
              type="text"
              placeholder='Nom & Prenom'
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="input-field"
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              placeholder='Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input-field"
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              placeholder='Mot de passe'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input-field"
            />
          </div>

          {type === 'student' && (
            <div className="form-group">
              <input
                type="text"
                placeholder='Votre nationalité'
                value={nationality}
                onChange={(e) => setNationality(e.target.value)}
                required
                className="input-field"
              />
            </div>
          )}

          {type === 'university' && (
            <>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Adresse de l'université (Ville)"
                  value={address.city}
                  onChange={(e) => setAddress({ ...address, city: e.target.value })}
                  required
                  className="input-field"
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  placeholder="Adresse de l'université (Pays)"
                  value={address.country}
                  onChange={(e) => setAddress({ ...address, country: e.target.value })}
                  required
                  className="input-field"
                />
              </div>
            </>
          )}

          <button type="submit" className="submit-button">S'inscrire</button>
        </form>
      </Box>
    </Box>
  );
};

export default RegisterForm;
